"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesComponent = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const PropertiesComponent = ({ element, onCancel, dragHandleRef, dragListeners, dragAttributes, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const propertiesElem = (0, react_1.useRef)(null);
    // Settings button removed - clicking on field directly selects it for property editing
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "absolute left-[100%] top-1/2 -translate-y-1/2 mx-1 md:mx-2 z-10", onClick: (e) => {
                e.stopPropagation();
            }, onMouseDown: (e) => {
                e.stopPropagation();
            } },
            react_1.default.createElement("div", Object.assign({ ref: dragHandleRef }, dragListeners, dragAttributes, { className: "cursor-grab active:cursor-grabbing bg-primary text-white p-1.5 rounded-full shadow-md hover:scale-110 transition-transform flex items-center justify-center", style: { touchAction: "none" }, title: "Drag to move" }),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faArrowsAlt, style: { minWidth: 16, minHeight: 16 } })))));
};
exports.PropertiesComponent = PropertiesComponent;
